import * as React from 'react';
import { getTimeZoneShortDisplayName } from 'owa-timezone';
import { SurfaceConstants, toPixelString } from 'owa-calendar-surface-core';
import { observer } from 'mobx-react';

const styles = require('./TimeStripHeaderBehavior.scss');

/* tslint:disable:use-mobx-react-lite-with-hooks
 * Using mobx-react-lite with functional components breaks the Calendar "behavior" architecture.
 * WI:47082 tracks refactoring this architecture.
 */
export default observer(function TimeStripHeaderBehavior({
    headerWidth = SurfaceConstants.timeStripDefaultWidth,
    timeZones = [],
}: {
    headerWidth?: number;
    timeZones?: string[];
}) {
    const headerPixelString = toPixelString(headerWidth);
    const timeZoneWidthStyle = { width: headerPixelString };

    return (
        <>
            {timeZones
                .map(timeZoneId => (
                    <div
                        key={timeZoneId}
                        className={styles.timeZonePanel}
                        style={timeZoneWidthStyle}>
                        {getTimeZoneShortDisplayName(timeZoneId)}
                    </div>
                ))
                .reverse()}
        </>
    );
});
